module.exports = __webpack_public_path__ + "static/media/equal-salary-main-baner-phone.8a76d9e2.png";